import React from "react";
// import { ReactComponent as OnIcon } from "../../../assets/images/icon-toggle-actve.svg";
// import { ReactComponent as OffIcon } from "../../../assets/images/icon-toggle-inactive.svg";
// import useCustomStyles from "../../../hooks/useCustomStyles";
// import { activeInactiveButtonStyles } from "../../../assets/styles/ClientsStyles/activeInactiveButtonStyles";
// import { useSelector } from "react-redux";
// import { selectState } from "../../../store/slices/themeSlice";
// import { activeClientInfoStyles } from "../../../assets/styles/ClientsStyles/activeClientInfoStyles";

// interface ActiveInActiveButtonProps {
//   mainText: string;
//   selected: boolean;
//   onPress?: () => void;
// }

// const ActiveInActiveButton: React.FC<ActiveInActiveButtonProps> = ({
//   mainText,
//   selected,
//   onPress,
// }) => {
//   //   const schemaColor = useSelector(selectConfigTheme);
//   const { theme } = useSelector(selectState);

//   const classes = useCustomStyles(activeClientInfoStyles, theme);
//   return (
// <button
//   onClick={onPress}
//   style={{
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     width: "45%",
//     backgroundColor: "#F6F6F6",
//     // background: "red",
//     borderRadius: 8,
//     height: 50,
//     justifyContent: "space-between",
//     margin: "8px",
//     border: "none",
//     cursor: "pointer",
//   }}
// >
//       <span
//         style={{
//           fontSize: 18,
//           fontFamily: "Gilroy-Regular",
//           color: selected ? "#000" : "#6B6B6B",
//           marginLeft: 16,
//           fontWeight: "400",
//           // flex: 1,
//         }}
//       >
//         {mainText}
//       </span>
//       <div>
//         {selected ? (
//           <OnIcon height={35} width={35} />
//         ) : (
//           <OffIcon height={35} width={35} />
//         )}
//       </div>
//     </button>
//   );
// };

// export default ActiveInActiveButton;import React from "react";
import { ReactComponent as OnIcon } from "../../../assets/images/icon-toggle-actve.svg";
import { ReactComponent as OffIcon } from "../../../assets/images/icon-toggle-inactive.svg";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { useSelector } from "react-redux";
import { selectState } from "../../../store/slices/themeSlice";
import { activeClientInfoStyles } from "../../../assets/styles/ClientsStyles/activeClientInfoStyles";

interface ActiveInActiveButtonProps {
  mainText: string;
  selected: boolean;
  onPress?: () => void;
  isWithWhiteBackground?: boolean;
}

const ActiveInActiveButton: React.FC<ActiveInActiveButtonProps> = ({
  mainText,
  selected,
  onPress,
  isWithWhiteBackground = false,
}) => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(activeClientInfoStyles, theme);
  return (
    <button
    type="button"
      style={{
        backgroundColor: isWithWhiteBackground ? "#fff" : "#F6F6F6",
      }}
      onClick={onPress}
      className={classes.root}
    >
      <span
        style={{
          ...(classes.textBase as React.CSSProperties),
          color: selected ? "#000" : "#6B6B6B",
        }}
      >
        {mainText}
      </span>
      <div>
        {selected ? (
          <OnIcon height={35} width={35} />
        ) : (
          <OffIcon height={35} width={35} />
        )}
      </div>
    </button>
  );
};

export default ActiveInActiveButton;
